import { BaseRequest } from './BaseRequest';

export class MigrateWhatsAppRequest extends BaseRequest {
    DestinationBotIdentity : string | null;

    constructor(destinationBotIdentity?: string, botIdentifier?: string, clusterName?: string) {
      super();
      this.DestinationBotIdentity = destinationBotIdentity;
      this.ClusterName = clusterName;
      this.BotIdentifier = botIdentifier;
    }
}